/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button, Col, Form, FormGroup, Input, InputGroup, Row, Table } from 'reactstrap';
import { JhiItemCount, JhiPagination, Translate, getPaginationState, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import { ASC, DESC, ITEMS_PER_PAGE, SORT } from 'app/shared/util/pagination.constants';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities, searchEntities } from './treatment-radiation-dosimetry.reducer';

export const TreatmentRadiationDosimetry = () => {
  const dispatch = useAppDispatch();

  const pageLocation = useLocation();
  const navigate = useNavigate();

  const [search, setSearch] = useState('');
  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getPaginationState(pageLocation, ITEMS_PER_PAGE, 'id'), pageLocation.search),
  );

  const treatmentRadiationDosimetryList = useAppSelector(state => state.treatmentRadiationDosimetry.entities);
  const loading = useAppSelector(state => state.treatmentRadiationDosimetry.loading);
  const totalItems = useAppSelector(state => state.treatmentRadiationDosimetry.totalItems);

  const getAllEntities = () => {
    if (search) {
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    } else {
      dispatch(
        getEntities({
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
  };

  const startSearching = e => {
    if (search) {
      setPaginationState({
        ...paginationState,
        activePage: 1,
      });
      dispatch(
        searchEntities({
          query: search,
          page: paginationState.activePage - 1,
          size: paginationState.itemsPerPage,
          sort: `${paginationState.sort},${paginationState.order}`,
        }),
      );
    }
    e.preventDefault();
  };

  const clear = () => {
    setSearch('');
    setPaginationState({
      ...paginationState,
      activePage: 1,
    });
    dispatch(getEntities({}));
  };

  const handleSearch = event => setSearch(event.target.value);

  const sortEntities = () => {
    getAllEntities();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (pageLocation.search !== endURL) {
      navigate(`${pageLocation.pathname}${endURL}`);
    }
  };

  useEffect(() => {
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort, search]);

  useEffect(() => {
    const params = new URLSearchParams(pageLocation.search);
    const page = params.get('page');
    const sort = params.get(SORT);
    if (page && sort) {
      const sortSplit = sort.split(',');
      setPaginationState({
        ...paginationState,
        activePage: +page,
        sort: sortSplit[0],
        order: sortSplit[1],
      });
    }
  }, [pageLocation.search]);

  const sort = p => () => {
    setPaginationState({
      ...paginationState,
      order: paginationState.order === ASC ? DESC : ASC,
      sort: p,
    });
  };

  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });

  const handleSyncList = () => {
    sortEntities();
  };

  const getSortIconByFieldName = (fieldName: string) => {
    const sortFieldName = paginationState.sort;
    const order = paginationState.order;
    if (sortFieldName !== fieldName) {
      return faSort;
    }
    return order === ASC ? faSortUp : faSortDown;
  };

  return (
    <div>
      <h2 id="treatment-radiation-dosimetry-heading" data-cy="TreatmentRadiationDosimetryHeading">
        <Translate contentKey="tinyMedicRestApp.treatmentRadiationDosimetry.home.title">Treatment Radiation Dosimetries</Translate>
        <div className="d-flex justify-content-end">
          <Button className="me-2" color="info" onClick={handleSyncList} disabled={loading}>
            <FontAwesomeIcon icon="sync" spin={loading} />{' '}
            <Translate contentKey="tinyMedicRestApp.treatmentRadiationDosimetry.home.refreshListLabel">Refresh List</Translate>
          </Button>
          <Link
            to="/treatment-radiation-dosimetry/new"
            className="btn btn-primary jh-create-entity"
            id="jh-create-entity"
            data-cy="entityCreateButton"
          >
            <FontAwesomeIcon icon="plus" />
            &nbsp;
            <Translate contentKey="tinyMedicRestApp.treatmentRadiationDosimetry.home.createLabel">
              Create new Treatment Radiation Dosimetry
            </Translate>
          </Link>
        </div>
      </h2>
      <Row>
        <Col sm="12">
          <Form onSubmit={startSearching}>
            <FormGroup>
              <InputGroup>
                <Input
                  type="text"
                  name="search"
                  defaultValue={search}
                  onChange={handleSearch}
                  placeholder={translate('tinyMedicRestApp.treatmentRadiationDosimetry.home.search')}
                />
                <Button className="input-group-addon">
                  <FontAwesomeIcon icon="search" />
                </Button>
                <Button type="reset" className="input-group-addon" onClick={clear}>
                  <FontAwesomeIcon icon="trash" />
                </Button>
              </InputGroup>
            </FormGroup>
          </Form>
        </Col>
      </Row>
      <div className="table-responsive">
        {treatmentRadiationDosimetryList && treatmentRadiationDosimetryList.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th className="hand" onClick={sort('id')}>
                  <Translate contentKey="tinyMedicRestApp.treatmentRadiationDosimetry.id">Id</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('id')} />
                </th>
                <th className="hand" onClick={sort('administeredDoseDistribution')}>
                  <Translate contentKey="tinyMedicRestApp.treatmentRadiationDosimetry.administeredDoseDistribution">
                    Administered Dose Distribution
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('administeredDoseDistribution')} />
                </th>
                <th className="hand" onClick={sort('administeredDoseCalcAlgorithm')}>
                  <Translate contentKey="tinyMedicRestApp.treatmentRadiationDosimetry.administeredDoseCalcAlgorithm">
                    Administered Dose Calc Algorithm
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('administeredDoseCalcAlgorithm')} />
                </th>
                <th className="hand" onClick={sort('administeredDoseGrid')}>
                  <Translate contentKey="tinyMedicRestApp.treatmentRadiationDosimetry.administeredDoseGrid">
                    Administered Dose Grid
                  </Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('administeredDoseGrid')} />
                </th>
                <th className="hand" onClick={sort('active')}>
                  <Translate contentKey="tinyMedicRestApp.treatmentRadiationDosimetry.active">Active</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('active')} />
                </th>
                <th className="hand" onClick={sort('cursor')}>
                  <Translate contentKey="tinyMedicRestApp.treatmentRadiationDosimetry.cursor">Cursor</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('cursor')} />
                </th>
                <th className="hand" onClick={sort('lastUpdated')}>
                  <Translate contentKey="tinyMedicRestApp.treatmentRadiationDosimetry.lastUpdated">Last Updated</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('lastUpdated')} />
                </th>
                <th className="hand" onClick={sort('microSec')}>
                  <Translate contentKey="tinyMedicRestApp.treatmentRadiationDosimetry.microSec">Micro Sec</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('microSec')} />
                </th>
                <th className="hand" onClick={sort('timestampEntry')}>
                  <Translate contentKey="tinyMedicRestApp.treatmentRadiationDosimetry.timestampEntry">Timestamp Entry</Translate>{' '}
                  <FontAwesomeIcon icon={getSortIconByFieldName('timestampEntry')} />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.treatmentRadiationDosimetry.radiationSession">Radiation Session</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th>
                  <Translate contentKey="tinyMedicRestApp.treatmentRadiationDosimetry.dosimetry">Dosimetry</Translate>{' '}
                  <FontAwesomeIcon icon="sort" />
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {treatmentRadiationDosimetryList.map((treatmentRadiationDosimetry, i) => (
                <tr key={`entity-${i}`} data-cy="entityTable">
                  <td>
                    <Button tag={Link} to={`/treatment-radiation-dosimetry/${treatmentRadiationDosimetry.id}`} color="link" size="sm">
                      {treatmentRadiationDosimetry.id}
                    </Button>
                  </td>
                  <td>{treatmentRadiationDosimetry.administeredDoseDistribution}</td>
                  <td>{treatmentRadiationDosimetry.administeredDoseCalcAlgorithm}</td>
                  <td>{treatmentRadiationDosimetry.administeredDoseGrid}</td>
                  <td>{treatmentRadiationDosimetry.active ? 'true' : 'false'}</td>
                  <td>{treatmentRadiationDosimetry.cursor}</td>
                  <td>{treatmentRadiationDosimetry.lastUpdated}</td>
                  <td>{treatmentRadiationDosimetry.microSec}</td>
                  <td>{treatmentRadiationDosimetry.timestampEntry}</td>
                  <td>
                    {treatmentRadiationDosimetry.radiationSession ? (
                      <Link to={`/treatment-radiation/${treatmentRadiationDosimetry.radiationSession.id}`}>
                        {treatmentRadiationDosimetry.radiationSession.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td>
                    {treatmentRadiationDosimetry.dosimetry ? (
                      <Link to={`/radiation-dosimetry/${treatmentRadiationDosimetry.dosimetry.id}`}>
                        {treatmentRadiationDosimetry.dosimetry.id}
                      </Link>
                    ) : (
                      ''
                    )}
                  </td>
                  <td className="text-end">
                    <div className="btn-group flex-btn-group-container">
                      <Button
                        tag={Link}
                        to={`/treatment-radiation-dosimetry/${treatmentRadiationDosimetry.id}`}
                        color="info"
                        size="sm"
                        data-cy="entityDetailsButton"
                      >
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button
                        tag={Link}
                        to={`/treatment-radiation-dosimetry/${treatmentRadiationDosimetry.id}/edit?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`}
                        color="primary"
                        size="sm"
                        data-cy="entityEditButton"
                      >
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button
                        onClick={() =>
                          (window.location.href = `/treatment-radiation-dosimetry/${treatmentRadiationDosimetry.id}/delete?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`)
                        }
                        color="danger"
                        size="sm"
                        data-cy="entityDeleteButton"
                      >
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="tinyMedicRestApp.treatmentRadiationDosimetry.home.notFound">
                No Treatment Radiation Dosimetries found
              </Translate>
            </div>
          )
        )}
      </div>
      {totalItems ? (
        <div className={treatmentRadiationDosimetryList && treatmentRadiationDosimetryList.length > 0 ? '' : 'd-none'}>
          <div className="justify-content-center d-flex">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </div>
          <div className="justify-content-center d-flex">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default TreatmentRadiationDosimetry;
